
        Component.define('newsletter', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

 // const api = ws_url+'/newsletter';

const $el = $(el);

// const api = (params.insideFeed) ? ws_url+'/save.php?insideFeed=true' : ws_url+'/save.php';
const api = (params.insideFeed) ? 'https://live.tt/ws/save.php?insideFeed=true' : 'https://live.tt/ws/save.php';

let successEN = '<label>Thank you! : ) Everything is set now. Keep an eye on your inbox as we will soon send updates from liⱴε.</label>';
let successPT = '<label>Obrigadx! : ) Agora tudo certo. Fique de olho no seu inbox que em breve enviaremos novidades da liⱴε.</label>';

if (params.type == 'modal') {
    successEN = successEN + '<button class="send close-modal"><span>Close</span></button>';
    successPT = successPT + '<button class="send close-modal"><span>Fechar</span></button>';
}

let count = 0;
$el.on('click', '.btn-presentation', function() {
    count++;
});

$el.find('form').on('submit', function(event) {
    event.preventDefault();

    const $this   = $(this);
    const $button = $this.find('button');

    if (!$button.hasClass('close-modal')) {
        $button.addClass('loading');

        const email = $('[name="email"]', this).val();

        let optin = true;

        if(params.insideFeed) {
            if (!$('[name="optin"]').is(":checked")) {
                optin = false;
            }
        }

        if (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
            // $.post('ws/save.php', { email: email, lang: lang }).then((res) => {
            $.post(api, { email: email, lang: lang, optin: optin }).then((res) => {
                if(params.insideFeed) {
                    if (res.success && lang == 'pt-br') {
                        // const presentationLink = 'https://bit.ly/live-homeoffice';
                        // const presentationLink = 'https://docs.google.com/presentation/d/e/2PACX-1vSLZ9ZSJAOC_x0kVinbB4_JGi1_wPRNca_-HB11SzKiuxteQjgkTuSMFwNphgQanC8LrHnEcYHInGvS/pub?start=true&loop=false&delayms=60000&slide=id.g4eb9f18206_0_0';
                        const presentationLink = 'https://docs.google.com/presentation/d/e/2PACX-1vQTvh4K36uaL5z7vYRbjlPZ2iLtKDVJaWiY0qAno1Ql5ZuxhKoey1EitCXzeQaqW5qoXfC0HKZZHRCr/pub?start=false&loop=false&delayms=3000&slide=id.g7189c8a1a4_4_0';

                        $this.html(`<div><label>
                            Obrigado pelo interesse.<br>esperamos que goste do nosso documento!<br><br>

                            <a class="btn-presentation" target="_blank" href="${presentationLink}">Click aqui e acesse</a>
                        </label></div>`);

                        setInterval(() => {
                            if(count === 0) {
                                window.location.href = presentationLink;
                            }
                        }, 5000);
                    }
                } else {
                    if (res.success && lang == 'en') {
                        $this.html('<div>' + successEN + '</div>');
                    } else if (res.success && lang == 'pt-br') {
                        $this.html('<div>' + successPT + '</div>');
                    } else {
                        // Error on save
                    }
                }
            });
        } else {
            // Error email invalid
        }
    }
});

        });